import Marionette from 'backbone.marionette';
import memberBillItemviewTmpl from '../templates/member_bills_itemview.tpl';
export default Marionette.ItemView.extend({
  template: memberBillItemviewTmpl,
  tagName: "tr"

  /*
  onShow: function() {
    const prob = this.model.get("predictions") * 100;
    this.$(".well").addClass(
      prob <= 20 ? "less-likely" :
      prob < 80 ? "likely" :
      "more-likely"
    );
  }
  */
});